// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__1a5w_","resendInfoText":"OnGoingPaymentBox_resendInfoText__1UseD"};